require('intersection-observer');

import Vue from 'vue';
import VueObserveVisibility from 'vue-observe-visibility/src'

Vue.use(VueObserveVisibility);
Vue.use(require('vue-resource'));
Vue.http.headers.common['X-CSRFToken'] = getCookie('csrftoken');

var moment = require('moment');
require('moment/locale/pl');
Vue.use(require('vue-moment'), {
    moment
});


import App from './App.vue';

new Vue({
    el: '#app',
    render: h => h(App)
});

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}



// WEBPACK FOOTER //
// ./app/main.js